const React = require('react');
const T = require('prop-types');

const FullScreenDialog = require('containers/FullScreenDialog');
const { default: Classes } = require('./styles.scss');

const ManageGroupsContents = require('containers/ManageGroupsContents');
const ManageOwnGroupsContents = require('containers/ManageOwnGroupsContents');
const ManageGroupsSearchField = require('components/ManageGroupsSearchField');

const { useState } = React;

const ManageGroupsDialog = (props) => {

    const {
        open,
        onRequestClose,
        currentGroups,
        myCurrentGroups,
        user,
        isMe,
        debug
    } = props;

    const [searchText, setSearchText] = useState('');

    const contentsProps = {
        user,
        currentGroups,
        myCurrentGroups,
        searchText,
        setSearchText,
        debug
    };

    return (
        <FullScreenDialog
            open={open}
            onRequestClose={onRequestClose}
            className={Classes.wrapper}
            fullWidth
            title={(
                <span className={Classes.title}>
                    {isMe ? 'Manage Groups' : `Manage ${user.firstName}'s Groups`}
                </span>
            )}
            style={{ overflowY: 'hidden' }}
            fixedToTop={(
                <ManageGroupsSearchField
                    searchText={searchText}
                    setSearchText={setSearchText}
                />
            )}
        >
            {isMe && <ManageOwnGroupsContents {...contentsProps} />}
            {!isMe && <ManageGroupsContents {...contentsProps} />}
        </FullScreenDialog>
    );
};

ManageGroupsDialog.propTypes = {
    open: T.bool,
    onRequestClose: T.func,
    currentGroups: T.arrayOf(T.shape({ id: T.any.isRequired, name: T.string })) || [],
    myCurrentGroups: T.arrayOf(T.shape({ id: T.any.isRequired, name: T.string })) || [],
    user: T.shape({
        id: T.any.isRequired,
        firstName: T.string
    }),
    isMe: T.bool,
    debug: T.bool
};

module.exports = ManageGroupsDialog;
